import { useEffect, useState } from 'react';

import { getImageUrl } from '@/utils/dedaloUtils';

/**
 * Loads natural width/height for each item's image URL.
 * @param {Array<Object>} data
 * @param {string} [urlKey='image'] — property name that holds the image URL
 * @returns {Object} map of image URL → { width, height }
 */
export function useImageDimensions(data, urlKey = 'image') {
    const [dims, setDims] = useState({});

    const urlsKey = data ? data.map((item) => item[urlKey]).join('|') : '';

    useEffect(() => {
        if (!data || data.length === 0) return;

        Promise.all(
            data.map(
                (item) =>
                    new Promise((resolve) => {
                        const url = item[urlKey];
                        const img = new window.Image();
                        img.onload = () =>
                            resolve([url, { width: img.naturalWidth, height: img.naturalHeight }]);
                        img.onerror = () => resolve([url, {}]);
                        img.src = getImageUrl(url);
                    })
            )
        ).then((entries) => setDims(Object.fromEntries(entries)));
    }, [urlsKey, urlKey]); // eslint-disable-line react-hooks/exhaustive-deps

    return dims;
}
